import {
  IsBoolean,
  IsDateString,
  IsEmail,
  IsNotEmpty,
  IsOptional,
  IsUUID,
  ValidateNested,
} from 'class-validator';

import { Type } from 'class-transformer';

export class StartSessionDto {
  @IsNotEmpty()
  number!: string;

  @IsNotEmpty()
  @IsUUID()
  spaceCategory!: string;

  @IsOptional()
  @IsEmail()
  email!: string;
}

export class EndDateAndNumberDto {
  @IsNotEmpty()
  number!: string;

  @IsOptional()
  @IsDateString()
  endDate!: Date;

  @IsOptional()
  @IsBoolean()
  isAdmin!: boolean;
}

export class StopSessionDto {
  @ValidateNested()
  @Type(() => EndDateAndNumberDto)
  endDateAndNumber!: { number: string; endDate: Date; isAdmin: boolean };
}

export class CartDto {
  @IsNotEmpty()
  cardNumber!: string;
}
